/**
 * The Smorgas Social lockup on the stakeholder portal, the same pair of files as the sign-in card
 * (AuthGate): the portal follows the theme, so it shows the dark-lettered logo in light and the white one
 * in dark. The files have no size of their own, hence width and height.
 */
export function PortalBrand({ label }: { label: string }) {
  return (
    // Wraps as a unit: the lockup is 6.5x wider than it is tall, and on a narrow phone the
    // label should drop UNDER it, not break mid-phrase.
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
      <img
        src="/smorgas-social-logo-light.svg"
        alt="Smorgas Social"
        width={183}
        height={28}
        className="h-7 w-auto shrink-0 dark:hidden"
      />
      <img
        src="/smorgas-social-logo.svg"
        alt="Smorgas Social"
        width={183}
        height={28}
        className="hidden h-7 w-auto shrink-0 dark:block"
      />
      <span className="whitespace-nowrap text-[0.9375rem] font-semibold tracking-tight text-ink">
        {label}
      </span>
    </div>
  );
}
